import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { doc, getDoc, Timestamp, updateDoc } from 'firebase/firestore'
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage'
import { db, storage } from '../configs/firebaseconfig'
import '../assets/css/editprojects.css'

const EditProject = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [project, setProject] = useState(null)
  const [loading, setLoading] = useState(true)
  const [newImages, setNewImages] = useState([])
  const [newProfileImage, setNewProfileImage] = useState(null)

  useEffect(() => {
    const fetchProject = async () => {
      const docRef = doc(db, 'Projects', id)
      const docSnap = await getDoc(docRef)
      if (docSnap.exists()) {
        const projectData = docSnap.data()
        if (projectData.date && projectData.date.toDate) {
          projectData.date = projectData.date
            .toDate()
            .toISOString()
            .split('T')[0]
        }
        setProject(projectData)
      } else {
        console.error('No such document!')
      }
      setLoading(false)
    }

    fetchProject()
  }, [id])

  const handleChange = e => {
    const { name, value } = e.target
    setProject(prevProject => ({
      ...prevProject,
      [name]: value
    }))
  }

  const handleDeleteImage = index => {
    const updatedImages = project.images.filter((_, i) => i !== index)
    setProject({ ...project, images: updatedImages })
  }

  const handleAddImages = async () => {
    if (newImages.length > 0) {
      const uploadedImageUrls = await Promise.all(
        newImages.map(async image => {
          const imageRef = ref(
            storage,
            `images/${id}/additionals_edit${image.name}`
          )
          await uploadBytes(imageRef, image)
          return await getDownloadURL(imageRef)
        })
      )
      const updatedImages = [...project.images, ...uploadedImageUrls]
      setProject({ ...project, images: updatedImages })
      setNewImages([])
      console.log('Images added successfully.', uploadedImageUrls)
    }
  }

  const handleFileChange = e => {
    const files = Array.from(e.target.files)
    setNewImages(prevImages => [...prevImages, ...files])
  }

  const handleProfileImageChange = async () => {
    if (newProfileImage) {
      const imageRef = ref(
        storage,
        `images/${id}/newProfile_${newProfileImage.name}`
      )
      await uploadBytes(imageRef, newProfileImage)
      const profileImageUrl = await getDownloadURL(imageRef)
      setProject({ ...project, profileImage: profileImageUrl })
      setNewProfileImage(null)
    }
  }

  const handleProfileImageFileChange = e => {
    const file = e.target.files[0]
    setNewProfileImage(file)
  }
  const handleSubmit = async e => {
    e.preventDefault()

    const updatedProject = {
      ...project
      // date: timestamp,
    }

    const docRef = doc(db, 'Projects', id)
    await updateDoc(docRef, updatedProject)
    navigate('/manageprojects')
  }

  if (loading) {
    return <div>Loading...</div>
  }

  return (
    <div className='edit-project-container'>
      <h1 className='edit-project-title'>Edit Project</h1>
      <form onSubmit={handleSubmit} className='edit-project-form'>
        <div>
          {project.profileImage && (
            <>
              <img
                src={project.profileImage}
                alt={project.name}
                className='project-image'
              />
            </>
          )}
        </div>
        <div>
          <label className='edit-project-label'>Change Profile Image:</label>
          <input
            type='file'
            onChange={handleProfileImageFileChange}
            className='edit-project-input'
          />
          <button
            type='button'
            onClick={handleProfileImageChange}
            className='edit-project-add-button'
          >
            Change Profile Image
          </button>
        </div>
        <div>
          <label className='edit-project-label'>Name:</label>
          <input
            type='text'
            name='name'
            value={project.name}
            onChange={handleChange}
            className='edit-project-input'
          />
        </div>
        <div>
          <label className='edit-project-label'>Category:</label>
          <select
            name="category"
            value={project.category || ''}
            onChange={handleChange}
            className='mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm'
          >
            <option value=''>Select a category</option>
            <option value='Architecture Design'>Architecture Design</option>
            <option value='Interior Design'>Interior Design</option>
            <option value='Construction Design'>Construction Design</option>
            <option value='Architecture & Interior Design'>
              Architecture & Interior Design
            </option>
            <option value='Architecture & Construction Design'>
              Architecture & Construction Design
            </option>
            <option value='Interior & Construction Design'>
              Interior & Construction Design
            </option>
          </select>
        </div>
        <div>
          <label className='edit-project-label'>Description:</label>
          <input
            type='text'
            name='description'
            value={project.description}
            onChange={handleChange}
            className='edit-project-input edit-project-description'
          />
        </div>
        <div>
          <label className='edit-project-label'>Date:</label>
          <input
            type='date'
            name='date'
            value={project.date}
            onChange={handleChange}
            className='edit-project-input'
          />
        </div>
        <div>
          <label className='edit-project-label'>Image URL:</label>
          {project.images && project.images.length > 0 ? (
            <div className='project-images'>
              {project.images.map((image, index) => (
                <div key={index} className='project-image-container'>
                  <img
                    src={image}
                    alt={`${project.name} ${index + 1}`}
                    className='project-image'
                  />
                  <button
                    type='button'
                    onClick={() => handleDeleteImage(index)}
                    className='button-delete'
                  >
                    Delete
                  </button>
                </div>
              ))}
            </div>
          ) : (
            <p>No images available</p>
          )}
        </div>
        <div>
          <label className='edit-project-label'>Add New Images:</label>
          <input
            type='file'
            multiple
            onChange={handleFileChange}
            className='edit-project-input'
          />
          <button
            type='button'
            onClick={handleAddImages}
            className='edit-project-add-button'
          >
            Add Images
          </button>
        </div>

        <button type='submit' className='edit-project-save-button'>
          Save
        </button>
      </form>
    </div>
  )
}

export default EditProject
